import StoryblokClient from 'storyblok-js-client';

const Storyblok = new StoryblokClient({
	accessToken: '12bvNrVBMvsGo3qf7cGURAtt',
	cache: {
		clear: 'manual',
		type: 'none',
	},
});

const getModels = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'modelos-de-relatorios/',
		per_page: 80,
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getForms = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'formularios/',
		per_page: 50,
		resolve_relations: 'Aplicacao.ProdutosPermitidos',
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getProblematics = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'problematicas/',
		per_page: 50,
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getPhases = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'fases/',
		resolve_relations: 'Fase.Secoes',
		per_page: 50,
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getCultures = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'culturas/',
		per_page: 100,
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getProducts = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'produtos/',
		per_page: 50,
	})
		.then((response) => {
			return response.data.stories;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};

const getStories = async () => {
	const data = Storyblok.get('cdn/stories', {
		starts_with: 'stories/',
		per_page: 50,
	})
		.then((response) => {
			return response.data;
		})
		.catch((error) => {
			console.error(error);
		});

	return data;
};


const getPanic = async () => {
	const data = Storyblok.get('cdn/stories/pcs')
	.then((response) => {
			const story = response.data.story
			return story;
		})
		.catch((error) => {
			console.error(error);
			return null
		});
	return data;
};

export {
	getModels,
	getPanic,
	getForms,
	getPhases,
	getProblematics,
	getCultures,
	getProducts,
	getStories,
};
